export default "__VITE_ASSET__DbzP6VoD__"